import { Links } from './links';


export class Page<T> extends Array<T> {

  _links: Links;
  count: number;
  pages: number;
  current: number;
  results: any[];
}



// WEBPACK FOOTER //
// ./src/app/Models/page.ts